import { ViewModel,View, ObservableArray } from "binder"
import  { DistrictTransferView } from "./districtTransfer-view"
import { IRequest } from "./IRequest";
import { RequestsViewModel } from "./requests/requests-viewModel";
import { RequestingViewModel } from "./requesting/requesting-viewModel";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class DistrictTransferViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'انتقال شعب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<IRequest>();
        this.items.update(...[
            new RequestsViewModel(this),
            new RequestingViewModel(this)
        ])
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictTransferView();
    }
    public getTypeId(): string {
        return "VM-A01F7D6F-88E9-4E00-8ADB-F9F68EFE79C6"
    }

    public set items(v: ObservableArray<IRequest>) { this._items = v; } public get items(): ObservableArray<IRequest> { return this._items;} private _items: ObservableArray<IRequest>;
    public set selectedItem(v: IRequest) { 
        this._selectedItem = v; 
        this.refresh();
    } public get selectedItem(): IRequest { return this._selectedItem;} private _selectedItem: IRequest;
    
    refresh(){
        if(this.selectedItem!=null)
            this.selectedItem.refresh();
    }
}
